module.exports = function (done, value) {
  return { value: value, done: !!done };
};



// WEBPACK FOOTER //
// webpack:///node_modules/core-js/modules/_iter-step.js